import React from 'react'
import { useEffect } from 'react'
import HeaderImage from '../../assets/NewProf.jpg'
import AOS from 'aos'
import 'aos/dist/aos.css'
import './header.css'
import data from './data'

const Header = () => {
  useEffect(()=>{
    AOS.init({duration: 2000})
  },[])

  return (
    <header id="header">
      <div className='container header__container'>
        <div className='header__profile' data-aos="flip-up">
          <img src={HeaderImage} alt="Header portait" />
        </div>
        <h5 data-aos="fade-up">Tushar Borse</h5>
        <p>(Software Engineer specializing in React.js)</p>
        {/* <p data-aos="fade-up">
        I build production-grade, data-intensive web applications and interactive dashboards. Currently working on an IoT-based industrial monitoring platform and expanding my full-stack expertise with Node.js, Express.js, and SQL.
        </p> */}
        <div className='header__cta' data-aos="fade-up">
          {/* <a href="#contact" className='btn primary'>Let's talk</a> */}
          <a href="#portfolio" className='btn primary'>View My Work</a>
        </div>
        <div className='header__socials'>
          {
            data.map(item=> <a key={item.id} href={item.link} target='_blank' rel='noopener noreferrer'>{item.icon}</a>)
          }
        </div>
      </div>
    </header>
  )
}

export default Header